module.exports = {"data":{"productitem":[{"id":1,"name":"所有類型","code":"all"},{"id":2,"name":"野外活動","code":"野外活動"},{"id":3,"name":"課程教學","code":"課程教學"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/json/productsitem.json
// module id = sSGD
// module chunks = 1